import { Dropdown, Option, OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";
import { FunctionComponent } from "react";
import { AVAILABLE_LANGUAGES } from "../../constants/config";

export const LanguageDropdown: FunctionComponent<{ language: string, onLanguageSelected: (ev: SelectionEvents, data: OptionOnSelectData) => void }> = ({ language, onLanguageSelected }) => {

    return (<><div className="language">Language: &nbsp;</div>
        <Dropdown size='small' value={language} selectedOptions={[language]} className="dropdown-language" onOptionSelect={onLanguageSelected}>
            {AVAILABLE_LANGUAGES.map((lang) => (
                <Option key={lang} text={lang} value={lang}>
                    <span className="dropdown-item">{lang}</span>
                </Option>
            ))}
        </Dropdown>
    </>)
}